"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { LinkPendingUnderline } from "@/components/link-pending-underline";

export function Navigation() {
  const pathname = usePathname();

  const links = [
    { href: "/dashboard", label: "Home" },
    { href: "/dashboard/sessions", label: "My Sessions" },
    { href: "/dashboard/experiments", label: "Experiments" },
  ];

  return (
    <div className="flex items-center gap-8">
      <Link href="/dashboard" className="flex items-center gap-2">
        <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center">
          <span className="text-white font-bold text-sm">W</span>
        </div>
        <span className="font-semibold text-gray-900 hidden sm:inline">Working Title</span>
      </Link>

      <nav className="flex items-center gap-1">
        {links.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            className={cn(
              "relative px-3 py-1.5 rounded-md text-sm font-medium transition-all",
              pathname === link.href
                ? "bg-gray-100 text-gray-900"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-50",
            )}
          >
            {link.label}
            <LinkPendingUnderline className="inset-x-3 bottom-0.5" />
          </Link>
        ))}
      </nav>
    </div>
  );
}
